import React from 'react';
import {
  teamMemberEmailMode,
  verifiedMemberEmails,
} from '../utils/teamMemberEmail';

const TeamMemberEmailField = ({ member, value, onChange, required = false, disabled = false }) => {
  const mode = teamMemberEmailMode(member);
  const verified = verifiedMemberEmails(member);

  if (mode === 'select') {
    const current = String(value || '').trim().toLowerCase();
    const currentIsVerified = verified.includes(current);
    return (
      <>
        <select name="email" value={value} onChange={onChange} required={required} disabled={disabled}>
          {!currentIsVerified && current && (
            <option value={value} disabled>{`${value} (not verified)`}</option>
          )}
          {verified.map((email) => <option key={email} value={email}>{email}</option>)}
        </select>
        <small className="form-help-text">Choose an email verified for this KeyFlo account.</small>
      </>
    );
  }

  if (mode === 'locked') {
    return (
      <>
        <input type="email" name="email" value={value} readOnly className="disabled-input" />
        <small className="form-help-text">
          This email belongs to a linked KeyFlo account. Remove and re-add the member to use a different person.
        </small>
      </>
    );
  }

  return (
    <input
      type="email"
      name="email"
      value={value}
      onChange={onChange}
      placeholder="Enter email address"
      required={required}
      readOnly={disabled}
      className={disabled ? 'disabled-input' : ''}
    />
  );
};

export default TeamMemberEmailField;
